import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from './utils';

import type { IAgentRunHistoryDto } from '@/types/agentsAgentDesk';
import type { ApiChatMessage } from '@/types/chat';
import type { IWorkflowActivityParams, TAgentRunHistoryParams, TWorkflowRunHistoryParams } from '@/types/workflowActivity';

export const workflowHistoryApi = createApi({
  reducerPath: 'workflowHistoryApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (build) => ({
    getComponentRunHistory: build.query({
      query: (params: { referenceId: string }) => ({
        url: 'workflow-run-history/get-component-run-history',
        method: 'GET',
        params,
      }),
    }),
    getWorkflowRunHistory: build.query({
      query: (params: { referenceId: string }) => ({
        url: 'workflow-run-history/get-workflow-run-history',
        method: 'GET',
        params,
      }),
    }),
    getWorkflowRunHistories: build.query({
      query: (params: TWorkflowRunHistoryParams) => ({
        url: 'workflow-run-history/get-workflow-run-histories',
        method: 'POST',
        body: params,
        params,
      }),
    }),
    getComponentRunHistories: build.query({
      query: (params: { page: number; limit: number; customerAgentId?: string; startAt?: string; endAt?: string; search?: string }) => ({
        url: 'workflow-run-history/get-component-run-histories',
        method: 'POST',
        body: params,
        params,
      }),
    }),
    getWorkflowActivity: build.query({
      query: (body: IWorkflowActivityParams) => ({
        url: 'workflow-run-history/get-workflow-run-histories-by-customer',
        method: 'POST',
        body,
      }),
    }),
    getAgentRunHistory: build.query<
      { items: IAgentRunHistoryDto[]; pagination: { page: number; limit: number; totalPages: number; total: number } },
      TAgentRunHistoryParams
    >({
      query: (params) => ({
        url: 'run-history/get-agent-run-histories',
        method: 'POST',
        body: params,
        params,
      }),
    }),
    createChatMessages: build.mutation({
      query: (params: { workflowRunHistoryId: string; messages: ApiChatMessage[] }) => ({
        url: 'workflow-run-history/create-chat-messages',
        method: 'POST',
        body: params,
      }),
    }),
  }),
});

export const {
  useGetComponentRunHistoryQuery,
  useGetComponentRunHistoriesQuery,
  useGetWorkflowRunHistoriesQuery,
  useLazyGetWorkflowRunHistoriesQuery,
  useLazyGetComponentRunHistoryQuery,
  useGetWorkflowRunHistoryQuery,
  useGetWorkflowActivityQuery,
  useCreateChatMessagesMutation,
  useGetAgentRunHistoryQuery,
} = workflowHistoryApi;
